import React, { Component } from 'react';
import Mailto from 'react-mailto.js';
import Fade from 'react-reveal/Fade';

// Images
import IconUIDesigner from './icons/iconUIDesigner';
import IconHacker from './icons/iconHacker';
import IconBackEndDev from './icons/iconBackEndDev';
import IconGraphicDesigner from './icons/iconGraphicDesigner';
import IconFrontEndDev from './icons/iconFrontEndDev';

class Join extends Component {
  render() {
    return (
      <div className="join">

        <div className="wrap">

          <Fade left>
          <h2>Be part of the most <strong>exciting</strong> startup in donkey&apos;s years.</h2>
          </Fade>

          <div className="icon-group">

            <div className="icon-container">
              <IconUIDesigner />
              <h4>UI/UX Designers</h4>
            </div>
            <div className="icon-container">
              <IconHacker />
              <h4>Hackers</h4>
            </div>
            <div className="icon-container">
              <IconBackEndDev />
              <h4>Node.js/Back-end Developers</h4>
            </div>
            <div className="icon-container">
              <IconGraphicDesigner />
              <h4>Graphic Designer</h4>
            </div>
            <div className="icon-container">
              <IconFrontEndDev />
              <h4>Front-end Developers</h4>
            </div>

          </div>

          <Fade right>
          <h3>
            <Mailto
              secure={true}
              to='earlyaccess@whofolio.com'
              subject="I want to join!">
              Join us &rarr;
            </Mailto>
          </h3>
          </Fade>

        </div>

      </div>
    );
  }
}

export default Join;



// WEBPACK FOOTER //
// ./src/assets/components/join.js